import React, {Suspense, useEffect, useState} from 'react';
import {Route, Routes } from 'react-router-dom';
import CustomerRoutes from '../Routes/CustomerRoutes.js';
import './app.css'
function App() {
  
  // const {token, setToken } = useToken({});
  useEffect(() => {
    document.title = "centerprism"
  })


  return (
    <div className='app'>
      <Routes>
        <Route path='/*' element={<CustomerRoutes/>} />
      </Routes>
    </div>
  );
}

export default App;